import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import MaintenanceScreen from "./components/MaintenanceScreen";
import reportWebVitals from "./utils/reportWebVitals";

/** Set to `false` and redeploy when enrollment is ready again (no env vars). */
const UNDER_MAINTENANCE = false;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  UNDER_MAINTENANCE ? (
    <MaintenanceScreen />
  ) : (
    <>
      <App />
    </>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
